import { render, staticRenderFns } from "./ReadingContextSelector.vue?vue&type=template&id=70f7e1b4&"
import script from "./ReadingContextSelector.vue?vue&type=script&lang=js&"
export * from "./ReadingContextSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports